import { isAbsoluteUrl } from "./../../_shared/media/is-absolute-url.js";
const deriveWixMediaId = (sourceValue) => {
  const trimmed = sourceValue.trim();
  if (!trimmed) {
    return void 0;
  }
  if (!isAbsoluteUrl(trimmed)) {
    if (trimmed.startsWith("video/")) {
      return void 0;
    }
    const withoutFolder = trimmed.startsWith("media/") ? trimmed.slice("media/".length) : trimmed;
    const fileId = withoutFolder.split("/")[0]?.trim();
    return fileId || void 0;
  }
  try {
    const url = new URL(trimmed);
    if (url.hostname !== "static.wixstatic.com") {
      return void 0;
    }
    const match = url.pathname.match(/^\/media\/([^/]+)/);
    return match?.[1];
  } catch {
    return void 0;
  }
};
export {
  deriveWixMediaId
};
//# sourceMappingURL=derive-wix-media-id.js.map
